export { default } from '../../../product/[productId]/[...productDetails]';
